import { useEffect } from "react";
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { SelectJSupplier } from "../../../../components/Selectors/jomla/SelectJSupplier";
import {
  JInvoice,
  setChangeSupplierDialog,
} from "../../../../app/slices/jomla/invoiceSlice";
import { HiOutlineArrowsRightLeft, HiOutlineTruck } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const ChangeSupplierForm = (props) => {
  const dispatch = useDispatch();

  const _ChangeSupplier = useSelector((state) => state.jInvoice.changeSupplier);
  const _SearchBody = useSelector((state) => state.jInvoice.searchBody);
  const _JSupplier = useSelector(
    (state) => state.jSupplier.jSuppliersList.data
  );
  const { control, reset, handleSubmit, setValue } = useForm({
    defaultValues: _ChangeSupplier.form,
  });

  const onSubmit = (data) => {
    dispatch(
      JInvoice.changeSupplier(
        _ChangeSupplier.form.j_invoice_id,
        {
          j_supplier_id: data.j_supplier_id,
        },
        _SearchBody
      )
    );
  };

  useEffect(() => {
    reset({ ..._ChangeSupplier.form });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_ChangeSupplier.form]);

  const handleDialog = () => {
    dispatch(setChangeSupplierDialog());
  };

  return (
    <FormDialog
      open={_ChangeSupplier.dialog}
      onClose={handleDialog}
      icon={<HiOutlineArrowsRightLeft />}
      title={"تعيين الطلب الى سائق"}
      subtitle="اختر المورد ثم احفظ التغييرات"
      onSubmit={handleSubmit(onSubmit)}
      saving={_ChangeSupplier.loading}
      loading={_ChangeSupplier.loading}
    >
      <SectionCard icon={<HiOutlineTruck />} title="المورد">
        <Grid item xs={12}>
          <Controller
            name="j_supplier_id"
            control={control}
            render={({ field }) => (
              <SelectJSupplier
                {...field}
                required
                onChange={(e, newValue) => {
                  setValue("j_supplier_id", newValue ? newValue.id : null);
                }}
                value={
                  _JSupplier.filter((x) => x.id === field.value)[0] ?? null
                }
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default ChangeSupplierForm;
